import type { JSX } from "react";
// components/ui/LanguageSelect.tsx

import { t } from "i18next";
import { AppConfig } from "@/common/appConfig";
import { interfaceLanguageOptions } from "@/common/constants";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Props {
  value: string;
  onChange: (language: string) => void;
}

export const DisplayLanguageSelect = ({
  value,
  onChange,
}: Props): JSX.Element => {
  // v3.2: labelled by its settings card's title, the languages by name.
  if (AppConfig.enableAppRedesign)
    return (
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          aria-labelledby="account-language"
          className="min-h-11 w-full sm:min-h-10 sm:max-w-sm"
          data-testid="display-language-select"
        >
          <SelectValue
            placeholder={t(
              "settings.account.interfacePreferences.interfaceLanguagePlaceholder",
            )}
          />
        </SelectTrigger>
        <SelectContent>
          {interfaceLanguageOptions.map((lang) => (
            <SelectItem key={lang.value} lang={lang.value} value={lang.value}>
              {lang.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );

  return (
    <div className="space-y-2">
      <Label>
        {t("settings.account.interfacePreferences.interfaceLanguageLabel")}
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue
            placeholder={t(
              "settings.account.interfacePreferences.interfaceLanguagePlaceholder",
            )}
          />
        </SelectTrigger>
        <SelectContent>
          {interfaceLanguageOptions.map((lang) => (
            <SelectItem key={lang.value} value={lang.value}>
              {lang.flag} {lang.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
